import { Navigate, useRoutes } from 'react-router-dom';

import { CONFIG } from 'src/global-config';

import { appsRoutes } from './apps';
import { authRoutes } from './auth';
import { mainRoutes } from './main';
import {billingRoutes} from './billing';
import { dashboardRoutes } from './dashboard';
import { publicRoutes } from './public';

// ----------------------------------------------------------------------

export function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to={CONFIG.auth.redirectPath} replace />,
    },

    // Apps
    ...appsRoutes,

    // Auth
    ...authRoutes,

    // Billing
    ...billingRoutes,

    // Dashboard
    ...dashboardRoutes,

    // Main
    ...mainRoutes,

    // Public
    ...publicRoutes,

    // No match
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
